import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idContactsContactLeadChannel']),
        getByWork: state => work => {
            return state.objs.filter(leadChannel => leadChannel.work === work);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idContactsContactLeadChannel'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idContactsContactLeadChannel'])
    },
}